import React from "react";

function KidsBraces() {
  return <div>KidsBraces</div>;
}

export default KidsBraces;
